var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceContainer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5144 0.125843C15.8164 -0.0419476 16.1836 -0.0419476 16.4856 0.125843L31.4856 8.45918C31.8031 8.63555 32 8.97017 32 9.33333V17.6667H30V9.92174L16 2.14396L2 9.92174V25.4116L16.4856 33.4592L15.5144 35.2075L0.514357 26.8742C0.196892 26.6978 0 26.3632 0 26V9.33333C0 8.97017 0.196892 8.63555 0.514357 8.45918L15.5144 0.125843Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4856 18.5408C16.1836 18.7086 15.8164 18.7086 15.5144 18.5408L0.514357 10.2075L1.48564 8.45917L16 16.5227L30.5144 8.45918L31.4856 10.2075L16.4856 18.5408Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2437 26.2561C25.5212 27.2067 23.3211 29.8627 21.281 29.8627V29.8593L21.274 29.8627C19.4663 29.8644 18 28.1028 18 25.9314C18 23.7599 19.4663 21.9983 21.2754 22L21.2825 22.0034V22C23.3225 22 25.5226 24.6544 26.2451 25.6066C26.2437 25.6066 26.5001 25.9314 26.5001 25.9314L26.2437 26.2561Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7564 26.2561C27.4789 27.2067 29.679 29.8627 31.7191 29.8627V29.8593L31.7261 29.8627C33.5338 29.8644 35.0001 28.1028 35.0001 25.9314C35.0001 23.7599 33.5338 21.9983 31.7247 22L31.7176 22.0034V22C29.6776 22 27.4775 24.6544 26.755 25.6066C26.7564 25.6066 26.5 25.9314 26.5 25.9314L26.7564 26.2561Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceContainer);
export default __webpack_public_path__ + "static/media/service-container.12223a0a5b3308e50d6dc31cce0cb139.svg";
export { ForwardRef as ReactComponent };